import { createFeature, createReducer, on } from "@ngrx/store";
import { dataCalendarApiActions } from "./actions";

export interface State {
  gera: string[];
  cj: string[];
  crude: string[];
  program: string[];
  planning: string[];
  prices: string[];
  budget: string[];
  variableCost: string[];
  operatingParameter: string[];
  loading: boolean;
  error: string;
}

export const initialState: State = {
  gera: [],
  cj: [],
  crude: [],
  program: [],
  planning: [],
  prices: [],
  budget: [],
  variableCost: [],
  operatingParameter: [],
  loading: false,
  error: '',
};

export const dataCalendarFeature = createFeature({
  name: 'dataCalendar',
  reducer: createReducer(
    initialState,
    on(dataCalendarApiActions.loadDataCalendarData, (state) => ({
      ...state,
      loading: true,
    })),
    on(
      dataCalendarApiActions.loadDataCalendarDataSuccess,
      (state, { gera, cj, crude, program, planning, prices, budget, variableCost, operatingParameter }) => {
        return ({
          ...state,
          gera: [...gera],
          cj: [...cj],
          crude: [...crude],
          program: [...program],
          planning: [...planning],
          prices: [...prices],
          budget: [...budget],
          variableCost: [...variableCost],
          operatingParameter: [...operatingParameter],
          loading: false,
        })
      }
    ),
    on(dataCalendarApiActions.loadDataCalendarDataFailure, (state) => ({
      ...state,
      loading: false,
      error: 'Failed to load data calendar data',
    }))
  ),
});



export const {
  selectLoading,
  selectCrude,
  selectPrices,
  selectGera,
  selectProgram,
  selectPlanning,
  selectCj,
  selectBudget,
  selectVariableCost,
  selectOperatingParameter,
} = dataCalendarFeature;
